import './LocationsGoogleMap.scss';
class LocationsGoogleMap {
    constructor( node ) {
        this.node = node;
        this.locations = JSON.parse( this.node.getAttribute('data-locations') );
        this.node.removeAttribute('data-locations');

        this.iconUrl = this.node.getAttribute('data-icon');
        this.scriptUrl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAjqBW9llSDdz-cURniKAsbwwh-bdcpGJc&libraries=marker';
    }
    init() {
        let t = this;

        let observer = new IntersectionObserver(
            ( entries, settings ) => {
                entries.forEach( (entry, index) => {
                    if( entry.isIntersecting ) {

                        window.theme.methods.loadScript( this.scriptUrl, 'google-maps-script' )
                        .then( (scriptAdded) => {
                            if( scriptAdded ) {
                                t.initMap();
                            }
                        });
                        observer.unobserve( entry.target );
                    }
                });
            },
            {
                threshold: 0,
                rootMargin: '200px 0px'
            }
        );
        observer.observe( t.node );

    }
    initMap() {
        let t = this;
        const { AdvancedMarkerElement, PinElement } = google.maps.importLibrary("marker");
        // console.log( t.locations );

        let mapObj = new google.maps.Map( t.node.querySelector('.LocationsGoogleMap__wrapper'), {
            // zoom: 14,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: true,
            scrollwheel: false,
            fullScreenControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapId: t.node.getAttribute('data-uniq'),
        } );
        mapObj.setMapTypeId( t.node.getAttribute('data-uniq') );
        mapObj.mapTypes.set( t.node.getAttribute('data-uniq') , new google.maps.StyledMapType([
            {
                "featureType": "administrative.locality",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#2c2e33"
                    },
                    {
                        "saturation": 7
                    },
                    {
                        "lightness": 19
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#ffffff"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#ffffff"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 100
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#bbc0c4",
                    },
                    {
                        "saturation": -93
                    },
                    {
                        "lightness": 31
                    },
                    {
                        "visibility": "simplified"
                    }
                    
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "hue": "#008eff"
                    },
                    {
                        "saturation": -93
                    },
                    {
                        "lightness": 31
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels",
                "stylers": [
                    {
                        "hue": "#bbc0c4"
                    },
                    {
                        "saturation": -93
                    },
                    {
                        "lightness": -2
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#e9ebed"
                    },
                    {
                        "saturation": -90
                    },
                    {
                        "lightness": -8
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#e9ebed"
                    },
                    {
                        "saturation": -90
                    },
                    {
                        "lightness": -8
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#e9ebed"
                    },
                    {
                        "saturation": 10
                    },
                    {
                        "lightness": 69
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#e9ebed"
                    },
                    {
                        "saturation": -78
                    },
                    {
                        "lightness": 67
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            }
        ]));
        
        // -- center on resize -- //
            google.maps.event.addListener(window, 'resize', function() {
                mapObj.setCenter( mapOptions.center );
            });
        // -- END -- //
        
        // -- add markers -- //
            let bounds = new google.maps.LatLngBounds();
            let markers = [];
            let icons = [];

            t.locations.forEach( ( row, index ) => {

                let icon = document.createElement('img');
                icon.src = t.iconUrl;
                icon.width = window.theme.methods.mixSize( 38, 52 );
                icons.push( icon );

                markers.push(
                    new google.maps.marker.AdvancedMarkerElement({
                        map: mapObj,
                        position: { lat: parseFloat(row.lati), lng: parseFloat(row.long) },
                        title: 'Fun Gymnastics '+row.name,
                        content : icons[index],
                    })
                );
                bounds.extend( markers[index].position );
            });


            mapObj.fitBounds( bounds );
            window.addEventListener('resize', () => {
                mapObj.fitBounds( bounds );
                markers.forEach( ( marker ) => {
                    marker.content.setAttribute('width', window.theme.methods.mixSize( 38, 52 ) );
                });
            });

            markers.forEach( ( marker, index ) => {
                if( t.locations[index].url ) {
                    marker.addEventListener('click', () => {
                        window.open( t.locations[index].url ,'_blank');
                    });
                }
            });

        // -- END -- //

    }
}
JSModules['LocationsGoogleMap'] = LocationsGoogleMap;
export default LocationsGoogleMap;